/* eslint-disable */
const RegionData = class{
  constructor() {
    this.$parent = document.querySelector('.as-region-selector')

    // 源数据
    this.$zoneData = document.querySelector('.as-zones-data')
    this.$regionData = document.querySelector('.as-regions-data')
    this.$localesData = document.querySelector('.as-selector-config-data')
    this.$settingsData = document.querySelector('.as-customize-app-settings-data')
    this.$alternateLinks = document.querySelectorAll('link[rel="alternate"]')
    
    if (!this.$parent || !this.$regionData) return
    this.$data = {}
    this.$settings = {}
    this.$showModal = false
    this.$alternateLinksArray = []

    this.$stores = this.$parent.querySelector('.as-stores-wrap')
    this.$selectedRegionCookie = 'selectedRegion'
    this.$selectedLangCookie = 'selectedLanguage'
    this.$host = window.location.host
    this.$path = window.location.pathname

    this.$targetRegion = {}

    // 设置cookie过期时间
    var now = new Date();
    now.setTime(now.getTime() + 3600 * 1e3 * 24 * 365 * 2);
    this.EXPIRES = now.toUTCString();

    this.$selectorModal = this.$parent.querySelector('.as-selector-modal')
    this.$selectorDropdown = this.$parent.querySelector('.as-selector-dropdown')
    this.init()
  }
  init() {
    this.handleMetaData()
    this.initSelectorStatus()
  }
  handleMetaData() {
    // 初始化数据
    this.$data.areas = this.$zoneData && JSON.parse(this.$zoneData.innerHTML)
    this.$data.regions = this.$regionData && JSON.parse(this.$regionData.innerHTML)
    const initLocales = JSON.stringify(
      {
        locales: []
      }
    )
    this.$data.locales = JSON.parse(this.$localesData && JSON.parse(this.$localesData.innerHTML).find(item => item.configType === 2)?.content || initLocales)?.locales
    this.$settings = this.$settingsData && JSON.parse(this.$settingsData.innerHTML).settings

    // 遍历rel="alternate"的link标签放入数组
    this.$alternateLinks.forEach(link => {
      let href = link.href
      if (!href.endsWith('/')) {
        href = href + '/'
      }
      const url = new URL(href)
      const hrefPath = url?.pathname
      const splitPath = hrefPath.split('/');
      const firstSlash = '/' + splitPath[1] + '/';
      const regex = /^\/[^/]+\/$/
      const match = firstSlash.match(regex)

      if (match) {
        const path = match[0]
        if (!path?.match(/(pages|products|collections|account|cart|search|blogs|404|policies)/)) {
          this.$alternateLinksArray.push(path)
        }
      }
    })

    // 匹配当前路径是否包含alternateLinksArray中的字段并替换
    this.$alternateLinksArray.forEach(alternateLink => {
      if (!this.$path.endsWith('/')) {
        this.$path = this.$path + '/'
      }

      if (this.$path.includes(alternateLink)) {
        this.$path = this.$path.replace(`${alternateLink}`, '/');
      }
    })

    // 不包含页面类型为404的情况
    if (this.$path.length > 1) {
      this.$data.regions.map(item => {
        if (document.body.dataset.template !== '404') { 
          if (item.websiteUrl.endsWith('/')) {
            item.websiteUrl = item.websiteUrl + this.$path?.substring(1)
          } else {
            item.websiteUrl = item.websiteUrl + this.$path
          }
        }
      })
    }
    this.$data.areas.map(item => {
      item.regions = this.$data.regions.filter(regionItem => regionItem.zoneId === item.id)
    })
  }
  initSelectorStatus() {
    if (this.$settings && !this.$settings.enableSelector) {
      this.$parent.remove()
      return
    } else {
      this.$parent.classList.remove('d-none')
    }
    this.initStyle()
    // 渲染页脚展示的国家和国旗
    this.renderSelectedStore()
    // 对数据排序
    this.sortRegionList()
    this.renderCopyWritting()
    this.renderRegionList()
    // 国旗，国家等配置
    this.initOtherSettings()
    this.initSelector()
  }
  initStyle() {
    this.$parent.style.backgroundColor = this.$settings?.selectorBg
    this.$parent.style.color = this.$settings?.selectorText
    if (this.$settings && this.$settings.selectorDropdown) {
      this.$wrap = this.$selectorDropdown
      this.$selectorDropdown.classList.remove('d-none')
      this.$selectorModal?.remove()
      this.$stores.style.backgroundColor = this.$settings?.selectorBg
      // 颜色等样式处理
    } else {
      this.$wrap = this.$selectorModal
      this.$selectorModal.classList.remove('d-none')
      this.$selectorDropdown && this.$selectorDropdown.remove()
      this.$showModal = true
      // 弹窗背景色处理
      this.$wrap.classList.add(this.$settings?.selectorModalStyle)
    }
  }
  sortRegionList() {
    if (this.$showModal && this.$settings?.showArea) {
      this.$data.areas.map((item) => {
        item.regions?.sort(this.sortData('name'))
      })
    }
    this.$data.regions.sort(this.sortData('name'))
  }
  sortData(property) {
    return function (a, b) {
      if (a[property] > b[property]) {
        return 1
      }
      if (a[property] < b[property]) {
        return -1
      }
      return 0
    }
  }
  renderCopyWritting() {
    if (!this.$showModal) return
    let targetLocale = this.$data.locales.find((item) => {
      var _a
      return item.isoCode == ((_a = this.$targetRegion) == null ? void 0 : _a.languageIsoCode)
    })
    // 渲染弹窗标题
    targetLocale && (targetLocale.title) && (this.$wrap.querySelector('.as-modal-title').textContent = targetLocale?.title)
  }
  renderRegionList() {
    if (this.$showModal) {
      // 渲染弹窗数据
      if (this.$settings?.showArea) {
        this.$data.areas.map((item, index) => {
          let newNode = document.createElement('div')
          let areaHtml =  this.$parent.querySelector('.as-modal-list-with-area-template').innerHTML.replace(/_{area}/g, item.name).replace(/_{index}/g, index)
          newNode.innerHTML = areaHtml
          // let collapseBtn = newNode.querySelector('.as-collapse-btn')
          // let collapseContent = newNode.querySelector('.as-collapse-content')
          // collapseBtn.dataset.bsTarget = `selector-${index}`
          // collapseContent.id = `selector-${index}`
          let regionWrap = newNode.querySelector('.as-regions-wrap')
          item.regions?.map(item => {
            var wrapper= document.createElement('li');
            wrapper.classList.add('col')
            let regionHtml = this.$parent.querySelector('.as-region-list-template').innerHTML.replace('_{url}', item.websiteUrl).replace('_{region}', item.localName || item.name).replace('_{language}', item.languageLocalName || item.languageName).replace('_{langCode}', item.languageIsoCode).replace(/_{isoCode}/g, item.isoCode.toUpperCase())
            wrapper.innerHTML = regionHtml
            regionWrap.appendChild(wrapper)
          })
          this.$wrap.querySelector('.as-modal-region-list-with-region').appendChild(newNode)   
        })
        this.initCollapse()
      } else {
        this.$data.regions.map((item) => {
          let newNode = document.createElement('li')
          newNode.classList.add('col')
          let listHtmlTemplate =  this.$parent.querySelector('.as-region-list-template').innerHTML
          let newHtml = listHtmlTemplate.replace('_{url}', item.websiteUrl).replace('_{region}', item.localName || item.name).replace('_{url}', item.websiteUrl).replace('_{language}', item.languageLocalName || item.languageName).replace('_{langCode}', item.languageIsoCode).replace(/_{isoCode}/g, item.isoCode.toUpperCase())
          newNode.innerHTML = newHtml
          this.$wrap.querySelector('.as-modal-region-list-without-region').appendChild(newNode)
        })
      } 
    } else {
      // 渲染下拉数据(多语言处理)
      let dropdownLists = this.$parent.querySelector('.as-dropdown-lists')
      if (!dropdownLists) return
      this.$data.regions.map((item) => {
        let newNode = document.createElement('li')
        let listHtmlTemplate =  this.$parent.querySelector('.as-list-html').innerHTML
        let newHtml = listHtmlTemplate.replace('_{url}', item.websiteUrl).replace('_{region}', item.localName || item.name).replace('_{language}', item.languageLocalName || item.languageName).replace('_{langCode}', item.languageIsoCode).replace(/_{isoCode}/g, item.isoCode.toUpperCase())
        newNode.innerHTML = newHtml
        dropdownLists.appendChild(newNode)
      })
    }
  }
  initCollapse() {
    let collapseBtn = this.$parent.querySelectorAll('.as-collapse-btn')
    collapseBtn.forEach((item) => {
      item.addEventListener('click', (event) => {
        item.classList.toggle('collapsed')
        item.ariaExpanded == 'true' ? (item.ariaExpanded = 'false') : (item.ariaExpanded = 'true')
        // setTimeout(() => {
        //   item.nextElementSibling.classList.remove('collapsing')
        //   item.nextElementSibling.classList.add('collapse')
        //   item.nextElementSibling.classList.toggle("show")
        // }, 350);
        // item.nextElementSibling.classList.add('collapsing')
        // item.nextElementSibling.classList.remove('collapse')
        item.nextElementSibling.classList.toggle("show")
      })
    })
  }

  getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
  }

  renderSelectedStore() {
    let $selectedRegion = this.$wrap.querySelector('.as-selected-store')
    let $selectedLanguage = this.$wrap.querySelector('.as-selected-language')
    let $selectedFlag= this.$wrap.querySelector('.as-featured-flag')

    let showCookieTarget
    let cookieTarget
    const langCookie = this.getCookie(this.$selectedLangCookie)
    let lang = navigator.language.toLowerCase().split('-')[0]
    if (langCookie) {
      lang = langCookie
    }
    const selectedRegionCookie = this.getCookie(this.$selectedRegionCookie)
    if (selectedRegionCookie != null) {
      const matchedRegions = this.$data.regions.filter((item) => {
        return item.isoCode.toUpperCase() === selectedRegionCookie.toUpperCase() && new URL(item.websiteUrl)?.host === this.$host
      })
      if (matchedRegions.length > 0) {
        const matchLangRegions = matchedRegions.filter((item) => item.languageIsoCode.toLowerCase() === lang)
        if (matchLangRegions.length > 0) {
          cookieTarget = matchLangRegions[0]
        } else {
          cookieTarget = matchedRegions[0]
        }
        showCookieTarget = true
      } else {
        showCookieTarget = false
      }
    }
    if (showCookieTarget) {
      this.$targetRegion = cookieTarget
    } else {
      try {
        const callback = (mutationList) => {
          mutationList.forEach((mutation) => {
            const $target = mutation.target
            switch (mutation.type) {
              case 'attributes':
                if (mutation.attributeName === 'data-country') {
                  const matchHostRegions = this.$data.regions.filter((item) => {
                    return new URL(item.websiteUrl)?.host === this.$host
                  })
                  const recomendRegion = matchHostRegions.find((item) => item.isRecommended)
                  if (matchHostRegions.length > 0) {
                    const matchCountryRegions = matchHostRegions.filter((item) => {
                      return item.isoCode.toUpperCase() === $target.getAttribute('data-country').toUpperCase()
                    })
                    const matchLangRegions = matchCountryRegions.filter((item) => {
                      return item.languageIsoCode.toLowerCase() === lang
                    })
                    if (matchLangRegions.length > 0) {
                      this.$targetRegion = matchLangRegions[0]
                    } else {
                      if (matchCountryRegions.length > 0) {
                        this.$targetRegion = matchCountryRegions[0]
                      } else {
                        this.$targetRegion = recomendRegion
                      }
                    }
                  } else {
                    this.$targetRegion = this.$data.regions.find((item) => item.isRecommended)
                  }
                  $selectedRegion && ($selectedRegion.textContent = this.$targetRegion?.localName || this.$targetRegion?.name)
                  $selectedLanguage && ($selectedLanguage.textContent = `( ${this.$targetRegion?.languageLocalName || this.$targetRegion?.languageName} )`)
                  $selectedFlag && ($selectedFlag.classList.add(`sc-${this.$targetRegion?.isoCode.toUpperCase()}`))
                  this.renderCopyWritting()
                  observer.disconnect()
                }
                break
            }
          })
        }

        const observer = new MutationObserver(callback)
        observer.observe(document.body, {
          attributes: true
        })
        this.$targetRegion = this.$data.regions.filter(item => new URL(item.websiteUrl)?.host === this.$host).find(item => item.isRecommended) || this.$data.regions.find(item => new URL(item.websiteUrl)?.host == this.$host) || this.$data.regions.find(item => item.isRecommended)
      } catch (error) {
        this.$targetRegion = this.$data.regions.find(item => item.isRecommended)
      }
    }

    $selectedRegion.textContent = this.$targetRegion?.localName || this.$targetRegion?.name
    const parsedUrl = new URL(this.$targetRegion.websiteUrl)
    const isAE = parsedUrl.hostname.startsWith('ae.')
    if (isAE && lang !== 'ar') { 
      // 针对中东IP 浏览器语言为非ar时 强制显示英文
      $selectedLanguage.textContent = `(English)`
    } else {
      $selectedLanguage.textContent = `(${this.$targetRegion?.languageLocalName || this.$targetRegion?.languageName})`
    }
    $selectedFlag?.classList.add(`sc-${this.$targetRegion?.isoCode.toUpperCase()}`)
  }

  initOtherSettings() {
    if (!this.$settings?.showLanguage) {
      this.$parent.classList.add('no-language')
    }
    if (!this.$settings?.showFlag) {
      this.$parent.classList.add('use-default-flag')
    }
  }
  initSelector() {
    this.$storeItem = this.$parent.querySelectorAll('.as-store')
    Array.from(this.$storeItem).map((item) => {
      item.addEventListener('click', () => {
        if (document.domain.split('.').slice(-2).join('.') !== 'myshopify.com') {
          if (item.dataset.regionCode === 'CN') return
          document.cookie=`${this.$selectedRegionCookie}=${item.dataset.regionCode};path=/;domain=${document.domain.split('.').slice(-2).join('.')};expires=${this.EXPIRES}`
          document.cookie=`${this.$selectedLangCookie}=${item.dataset.langCode};path=/;domain=${document.domain.split('.').slice(-2).join('.')};expires=${this.EXPIRES}`
        } else {
          document.cookie=`${this.$selectedRegionCookie}=${item.dataset.regionCode};path=/;expires=${this.EXPIRES}`
          document.cookie=`${this.$selectedLangCookie}=${item.dataset.langCode};path=/;expires=${this.EXPIRES}`
        }
      })
    })
  }

}
new RegionData()
